/**
 * 解析 HTML 字符串, 返回纯文本
 * @param html
 * @returns
 */
export function parseHtml(html: string = '') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
}

export function removeHistoryQueries(queryKeys: string[]) {
    // 处理 hash 路由模式：从 hash 中提取查询参数
    const hash = window.location.hash;
    const hashParts = hash.split('?');
    const hashPath = hashParts[0]; // 例如: #/package
    const queryString = hashParts[1] || ''; // 例如: payment_state=success

    const searchParams = new URLSearchParams(queryString);

    queryKeys.forEach((key) => {
        searchParams.delete(key);
    });

    const newSearch = searchParams.toString();
    const newHash = `${hashPath}${newSearch ? `?${newSearch}` : ''}`;
    const newUrl = `${window.location.pathname}${newHash}`;

    window.history.replaceState('', document.title, newUrl);
}
